<template>
    <div class="content-warpper">
        <div class="warpper-title">
            <i class="iconfont iconiconfont-kemu-copy"></i>
            基础得分统计
        </div>
        <div class="padding-sm">
            <el-table
                    :data="stuList"
                    header-row-class-name="table-header"
                    row-class-name="table-row"
                    alig="center"
                    fit
                    style="width: 100%"
            >
                <el-table-column label="题目">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.title }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="答案">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{  scope.row.x }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="正确答案">
                    <template slot-scope="scope">
                        <div class="table-item">
<!--                            <div v-for="(item,index) in scope.row.tured" :key="index">-->
<!--                                  {{ item.key }}  {{ item.value }}-->
<!--                            </div>-->
                          {{  scope.row.z }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="得分">
                    <template slot-scope="scope">
                        <div class="table-item">
                            {{ scope.row.x === scope.row.z?1:0 }}
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import {scoreNumList} from "@/api/projectOffice";

    export default {
        name: "examBasicStatistics",
        data() {
            return {
                exam_id: '',
                stuList: [],
                page: 1,
                total: 0,
                limit: 10,
            };
        },
        created() {
            this.$emit(
                "setIndex",
                '/projectOffice/examination',
                "当前位置：考试管理 > 成绩统计 > 基础得分统计",
                true
            );
            this.exam_id = this.$route.query.exam
            if (this.$route.query.page) {
                this.page = Number(this.$route.query.page)
            }
            this.getList()
            // this.getCertPercent()
        },
        methods: {

            async getList() {
                let _list = await scoreNumList(this.exam_id, this.$route.query.id, 1)
                _list.data.data.map(item=>{
                    // item.checked = String.fromCharCode(Number(item.answer) + 65) + item.choice[item.answer].value
                    // item.tured = item.choice.filter(item=>{ return item.sel});
                    // item.fen = item.choice[item.answer].sel ? 1 : 0
                  item.fen = 0
                  if(!item.z){
                    item.z = item.x
                    item.fen = 1
                  }
                })
                this.stuList = _list.data.data
            },
            //  修改路径
            setPath() {
                this.$router.push({
                    path: '/projectOffice/examBasicStatistics',
                    query: {
                        id: this.$route.query.id,
                        exam: this.$route.query.exam,
                        page: this.page,
                    }
                })
            },
        },
        watch: {
            page() {
                this.setPath()
            },
            $route() {
                this.getList();
            }
        }
    }
</script>

<style scoped lang="scss">

</style>